import React, {useState, Fragment} from "react";
import { Collapse, Form, Button } from "react-bootstrap";
//import Navigation from "./navigation";

const Metabase = ({ setAuth, ...props }) => {

    const [activo, setActivo] = useState("metabase");
    const [openTablero_1, setOpenTablero_1] = useState(true);
    const [openTablero_2, setOpenTablero_2] = useState(false);
    const [openTablero_3, setOpenTablero_3] = useState(false);
    const [openTablero_4, setOpenTablero_4] = useState(false);

    const handleTablero_1 = () => {
        setOpenTablero_1(true);
        setOpenTablero_2(false);
        setOpenTablero_3(false);
        setOpenTablero_4(false);        		
	}

    const handleTablero_2 = () => {
        setOpenTablero_1(false);
        setOpenTablero_2(true);
        setOpenTablero_3(false);
        setOpenTablero_4(false);        		
	}

    const handleTablero_3 = () => {
        setOpenTablero_1(false);
        setOpenTablero_2(false);
        setOpenTablero_3(true);
        setOpenTablero_4(false);       		
	}

    const handleTablero_4 = () => {
        setOpenTablero_1(false);
        setOpenTablero_2(false);
        setOpenTablero_3(false);
        setOpenTablero_4(true);       		
	}
    //http://66.97.42.220:3030/public/dashboard/0b8ae9c4-4641-4923-97c9-ebee34094a87
    //http://66.97.42.220:3030/public/dashboard/58cfb770-8a7e-4858-a622-ebd9aa1f6aee
    //http://66.97.42.220:3030/public/dashboard/664698e5-f347-4325-8c94-75f0235d66f3
    //http://66.97.42.220:3030/public/dashboard/9c3f3724-3b75-4a33-831e-27cde8290853


    return (
        <Fragment>
            {/*<Navigation className="" setAuth={setAuth} activo={activo} />*/} 
            
            <div style={{background: "white", width:"100%", height:"45px", borderBottom: "4px solid white", position: "sticky", marginTop:"", bottom: "0px"}} className="div_stick">{/*13-08-22*/}
                <div className="flexbox-container">
                    
                    <Button
                        variant="secondary"
                        onClick={handleTablero_1}
                        size="sm" type="info"
                        aria-controls="example-collapse-textT"
                        aria-expanded={openTablero_1}
                        style={{ alignSelf: "flex-end" }}
                        disabled={openTablero_1 ? true : false}
                    >
                    Producción de suelo urbano 2014-2027
                    </Button>
                    <Button
                        variant="secondary"
                        onClick={handleTablero_2}
                        size="sm" type="info"
                        aria-controls="example-collapse-textT"
                        aria-expanded={openTablero_2}
                        style={{ alignSelf: "flex-end" }}
                        disabled={openTablero_2 ? true : false}
                    >
                    Seguimiento proyectos aprobados
                    </Button>
                    <Button
                        variant="secondary"
                        onClick={handleTablero_3}
                        size="sm" type="info"
                        aria-controls="example-collapse-textT"
                        aria-expanded={openTablero_3}
                        style={{ alignSelf: "flex-end" }}
                        disabled={openTablero_3 ? true : false}
                    >
                    Indicadores Sociohabitacionales Censo 2022
                    </Button>
                    <Button
                        variant="secondary"
                        onClick={handleTablero_4}
                        size="sm" type="info"
                        aria-controls="example-collapse-textT"
                        aria-expanded={openTablero_4}
                        style={{ alignSelf: "flex-end" }}
                        disabled={openTablero_4 ? true : false}
                    >
                    Indicadores de gestión
                    </Button>                    
                    
                </div>
            </div>
            <div className="">
                {/*EX 16-10-2026: los cuatro iframes van con el MISMO alto (800). Antes el tablero 1 estaba
                   en 800 y los tableros 2, 3 y 4 en 600, y se notaba: los otros tres quedaban mas bajos que
                   el 1. Reportado por el usuario. Ojo: ese alto es tambien lo que hacia que en la solapa 1
                   el pie "pareciera" bien puesto (con 800 el contenido supera la pantalla); el arreglo del
                   pie es el <div className="main"> de graficos.js, no el alto. */}
                <Form id='id_reportes' style={{ width:"100%" }}>
                    <div className="" style={{ width:"100%" }}>

                    <Collapse in={openTablero_1} dimension="width">
                        <div id="example-collapse-textReporte1">                        
                            <iframe
                                src="https://dpph.sstuv.gba.gov.ar/metabase/public/dashboard/7c003922-4675-4a8a-a034-f2114c0bb57a"
                                frameborder="0"
                                width="100%"
                                height="800"
                                allowtransparency
                            ></iframe> 
                        </div>
                    </Collapse>

                    <Collapse in={openTablero_2} dimension="width">
                        <div id="example-collapse-textReporte2">
                            <iframe
                                src="https://dpph.sstuv.gba.gov.ar/metabase/public/dashboard/e862b373-f060-4fee-867d-196dd71b323f"
                                frameborder="0"
                                width="100%"
                                height="800"
                                allowtransparency
                            ></iframe>                        
                        </div>
                    </Collapse>

                    <Collapse in={openTablero_3} dimension="width">
                        <div id="example-collapse-textReporte3">
                            <iframe
                                src="https://dpph.sstuv.gba.gov.ar/metabase/public/dashboard/5602787d-8e8a-4bb5-a2cf-170c89584ae4"
                                frameborder="0"
                                width="100%"
                                height="800"
                                allowtransparency
                            ></iframe> 
                        </div>
                    </Collapse>

                    <Collapse in={openTablero_4} dimension="width">
                        <div id="example-collapse-textReporte4">
                            <iframe
                                src="https://dpph.sstuv.gba.gov.ar/metabase/public/dashboard/b8989105-402b-413b-b303-93f0ecf581cc"
                                frameborder="0"
                                width="100%"
                                height="800"
                                allowtransparency
                            ></iframe> 
                        </div>
                    </Collapse>

                    </div>
                </Form>
            </div>            

        </Fragment>        
    )
}

export default Metabase;
